import { outlinedInputClasses } from '@mui/material'

export const C1AutocompleteStyles = {
    textField: {
        [`& .${outlinedInputClasses.root}`]: {
            backgroundColor: 'background.default',
        },
    },
}
